import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_delivery-desk-12/artifacts/76spvmi3_3D4A54DE-AC29-47B8-ABEA-5150F325A161.png';

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const navItems = [
    { label: 'Como funciona', href: '/#como-funciona' },
    { label: 'Calcular frete', href: '/calcular', destaque: true },
    { label: 'Vantagens', href: '/#beneficios' },
    { label: 'O que pode enviar', href: '/regras-de-envio' },
    { label: 'Ajuda', href: '/#faq' },
  ];

  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur">
      <div className="max-w-[1240px] mx-auto px-5 lg:px-8 h-[72px] lg:h-[92px] flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img src={LOGO_URL} alt="In'Nova Envios" className="inn-logo-img" />
        </Link>

        <nav className="hidden lg:flex items-center gap-8 ml-auto mr-6">
          {navItems.filter((item) => item.destaque).map((item) => (
            <a key={item.label} href={item.href} className="text-[15px] font-bold text-slate-700 hover:text-[#2A5BC7] transition-colors">
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/login">
            <Button variant="ghost" className="text-[15px] font-bold text-slate-700 hover:text-[#2A5BC7] hover:bg-[#EAF1FF]">Entrar</Button>
          </Link>
          <Link to="/calcular">
            <Button className="inn-btn-primary rounded-full px-6 h-11 font-extrabold shadow-[0_10px_24px_rgba(247,120,32,0.28)]">Emitir frete com desconto</Button>
          </Link>
        </div>

        <button className="lg:hidden p-2 text-slate-700" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white">
          <div className="px-5 py-4 space-y-3">
            {navItems.map((item) => (
              <a key={item.label} href={item.href} onClick={() => setOpen(false)} className="block text-sm font-medium text-slate-700 hover:text-[#2A5BC7]">
                {item.label}
              </a>
            ))}
            <div className="pt-2 flex flex-col gap-2">
              <Link to="/login"><Button variant="outline" className="w-full">Entrar</Button></Link>
              <Link to="/calcular"><Button className="w-full inn-btn-primary">Emitir frete</Button></Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
